const routes = [
    {
        path: '/session/schedules/instructor',
        component: () => import('../pages/SessionInstructor.vue'),
        meta: {
            isAuthenticated: true,
            permission: 'eslattendance_getinstructorsessionsschedule'
        }
    },
];

export default routes;
